import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=1a2b6f3d&scoped=true"
import script from "./ArticleItem.vue?vue&type=script&lang=js"
export * from "./ArticleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b6f3d",
  null
  
)

export default component.exports